<div class="main-wrapper">
  <div class="container-div">
    <div class="header-div">
      <span class="logo"></span>
      <span class="main-header-text">
        Welcome to <br />
        Satsang Philanthropy {{ country | titlecase }}
      </span>
      <span class="sub-header-text">
        Sign in to the Satsang SSO portal using your Family Code. Don’t have one yet? Register now
        to get started!
      </span>
    </div>
    <div class="body-div">
      <button class="sat-primary-btn" style="justify-content: center" (click)="onLoginClick()">
        Sign in
      </button>
      <button
        class="sat-primary-btn"
        style="
          justify-content: center;
          background-color: transparent !important;
          color: var(--brand-primary) !important;
        "
        (click)="onRegisterClick()"
      >
        No Account? Register Now
      </button>
    </div>
  </div>

  <span class="contact-us"
    >Contact US: <a href="tel: +9779768615361">+977-9768615361</a> or
    <a href="mailto: satsangnepalphilanthropy@gmail.com "
      >satsangnepalphilanthropy&#64;gmail.com</a
    ></span
  >
</div>
